import { Grid } from '@mui/material';
import React from 'react';
import DashboardLayout from '../../layout/dashboard/DashboardLayout';
import TestCaseViewPage from '../../components/project-dashboard/test-cases/TestCaseViewPage';

const TestCasesDetailsPage = () => {
  return (
    <DashboardLayout>
      <Grid container spacing={2}>
        <Grid item md={12}>
          <TestCaseViewPage />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default TestCasesDetailsPage;
